import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const IDENTITY_INFO_EDIT_MODAL_OPEN = 'IDENTITY_INFO_EDIT_MODAL_OPEN'
export const IDENTITY_INFO_EDIT_MODAL_CLOSE = 'IDENTITY_INFO_EDIT_MODAL_CLOSE'
export const IDENTITY_INFO_EDIT_MODAL_CANCEL = 'IDENTITY_INFO_EDIT_MODAL_CANCEL'
export const IDENTITY_INFO_EDIT_MODAL_SAVE_CHANGES = 'IDENTITY_INFO_EDIT_MODAL_SAVE_CHANGES'
export const IDENTITY_INFO_EDIT_MODAL_VALIDATE = 'IDENTITY_INFO_EDIT_MODAL_VALIDATE'
export const IDENTITY_INFO_EDIT_MODAL_RESET = 'IDENTITY_INFO_EDIT_MODAL_RESET'

const open = (content) => ({
  type: IDENTITY_INFO_EDIT_MODAL_OPEN,
  content,
})

const close = () => ({
  type: IDENTITY_INFO_EDIT_MODAL_CLOSE,
})

const cancel = () => ({
  type: IDENTITY_INFO_EDIT_MODAL_CANCEL,
})

const saveChanges = (newData) => ({
  type: IDENTITY_INFO_EDIT_MODAL_SAVE_CHANGES,
  newData,
})

const validate = (isValidated) => ({
  type: IDENTITY_INFO_EDIT_MODAL_VALIDATE,
  isValidated,
})

const reset = () => ({
  type: IDENTITY_INFO_EDIT_MODAL_RESET,
})

export const openIdentityInfoModalDialog = (content) => (dispatch) => dispatch(open(content))

export const closeIdentityInfoModalDialog = () => (dispatch) => dispatch(close())

export const cancelIdentityInfoModalDialog = () => (dispatch) => dispatch(cancel())

export const saveChangesIdentityInfoModalDialog = (data) => (dispatch) => dispatch(saveChanges(data))

export const validateIdentityInfoModalDialog = (isValid) => (dispatch) => dispatch(validate(isValid))

export const resetIdentityInfoModalDialog = () => (dispatch) => dispatch(reset())

// API call to update identity
export const IDENTITY_INFO_EDIT_UPDATE_REQUEST = 'IDENTITY_INFO_EDIT_UPDATE_REQUEST'
export const IDENTITY_INFO_EDIT_UPDATE_SUCCESS = 'IDENTITY_INFO_EDIT_UPDATE_SUCCESS'
export const IDENTITY_INFO_EDIT_UPDATE_FAILURE = 'IDENTITY_INFO_EDIT_UPDATE_FAILURE'

export const updateIdentity = (id, body) => ({
  [CALL_API]: {
    endpoint: '/api/identities/' + id + '/',
    types: [IDENTITY_INFO_EDIT_UPDATE_REQUEST, IDENTITY_INFO_EDIT_UPDATE_SUCCESS, IDENTITY_INFO_EDIT_UPDATE_FAILURE],
    method: 'PUT',
    body,
    tokenType: API_JWT_TOKEN_NAME,
  },
})
